'use client';

import type { ReactNode } from 'react';

import { tv } from '../_lib/utils';
import { isValidRichText } from '../_lib/isValidRichText';
import type { leftCenterValues } from '../_lib/designTypesStore';
import { Text } from '../Text';

const styles = tv({
	slots: {
		base: 'container-sm py-10 md:py-0 flex flex-col gap-4',
	},
	variants: {
		align: {
			center: {
				base: 'text-center',
			},
			left: {
				base: 'text-left',
			},
		},
	},
});

export type TitleMediumSectionProps = {
	className?: string;
	label?: string;
	title: ReactNode;
	align?: (typeof leftCenterValues)[number];
	copy?: ReactNode;
};

export function TitleMediumSection(props: TitleMediumSectionProps) {
	const align = props.align ?? 'center';
	const { base } = styles({ align });

	return (
		<article data-component='TitleSection' className={base({ className: props.className })}>
			{props.label && (
				<Text as='span' className='opacity-80' styleType='label-sm'>
					{props.label}
				</Text>
			)}
			<Text as='h2' styleType={`heading-sm`}>
				{props.title}
			</Text>
			{isValidRichText(props.copy) && (
				<Text className={'max-w-[38.75rem]'} styleType='editorial-md'>
					{props.copy}
				</Text>
			)}
		</article>
	);
}
